var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmployeeCardHaikei4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blur1",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 161,
    result: "effect1_foregroundBlur"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "#6600FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#blur1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 468,
    fill: "#00CC99",
    r: 357
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 429,
    cy: 59,
    fill: "#6600FF",
    r: 357
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 705,
    cy: 586,
    fill: "#00CC99",
    r: 357
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459,
    cy: 598,
    fill: "#00CC99",
    r: 357
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 644,
    cy: 358,
    fill: "#6600FF",
    r: 357
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 781,
    cy: 50,
    fill: "#00CC99",
    r: 357
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeCardHaikei4);
export default __webpack_public_path__ + "static/media/employee-card-haikei-4.6b04e398800e49cf2bfe17547a448d0a.svg";
export { ForwardRef as ReactComponent };